// extracted by mini-css-extract-plugin
export default {"lable":"index_lable__j0jRl","complete":"index_complete__SRjmi","status0":"index_status0__EMAzc","status1":"index_status1__NX0-T","status2":"index_status2__h4JOF"};